import HelpTriggerStandalone from './HelpTriggerStandalone';
export * from './HelpTriggerStandalone';
export default HelpTriggerStandalone;
